'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onReady = exports.api = exports.user = exports.chat = undefined;

var _services = require('./services');

// function initialize(config) {
//     setChatConfig(config)
// }

// export { Chat as ChatComp, ChatBox as ChatBoxComp, getCurrentMeeting, getDisplayModeState, initialize }
exports.chat = _services.chat;
exports.user = _services.user;
exports.api = _services.api;
exports.onReady = _services.onReady; // import Chat, { getCurrentMeeting, getDisplayModeState } from './components/chat'
// import ChatBox from './components/chatbox'
// import { setChatConfig } from './common/helpers'


// WEBPACK FOOTER //
// ../chat/lib/index.js